export default "__VITE_ASSET__BfGQIxyz__"